import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/skills/$id/edit')({
  component: () => null,
});
